module.exports = __webpack_public_path__ + "fonts/Gibson-LightItalic.73b1e223.woff2";